import { GridColumnProps } from "@progress/kendo-react-grid";
import { TableConfig } from "../../types/types";

const col = (
	field: string,
	title: string,
	width: number
): GridColumnProps & { show: boolean } => ({
	field,
	title,
	width: `${width}px`,
	show: true,
});

// Default column layout for the article master-data grid. Order/width/visibility
// are merged with the per-user `grid_config_articles` config at render time.
export const articlesTableConfigDefault: TableConfig = {
	columns: [
		col("code_e", "Code", 110),
		col("lot", "Lot", 100),
		col("description_de", "Bezeichnung (D)", 200),
		col("description_fr", "Bezeichnung (F)", 200),
		col("description_it", "Bezeichnung (I)", 200),
		col("additional_text", "Zusatztext", 200),
		col("is_req_dr_tax", "Arztstr.", 90),
		col("composition", "Zusammensetzung", 200),
		col("manufacturer", "Hersteller", 200),
		col("cluster", "Cluster", 130),
		col("ce_number", "CE-Nummer", 120),
		col("unit", "Einheit", 90),
		col("type", "Typ", 140),
		col("purchase_price", "Einkaufspreis", 120),
		col("price", "Verkaufspreis", 120),
		col("margin", "Marge", 90),
		col("purchase_quantity", "Einkaufsmenge", 120),
		col("standard_quantity", "Menge", 90),
		col("stock_quantity", "Bestand", 90),
		col("modified_at", "Änderung", 130),
	],
	dataState: {},
};
